<template>
    <div class="not-found-container">
        <div class="content">
            <div class="icon-wrapper">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="access-denied-icon">
                    <circle cx="12" cy="12" r="10"></circle>
                    <line x1="4.93" y1="4.93" x2="19.07" y2="19.07"></line>
                </svg>
            </div>
            <h1>Access Denied</h1>
            <p class="message">You have no right to access this page</p>
            <p class="sub-message">Please contact your administrator if you believe this is an error.</p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FileNot'
};
</script>

<style scoped>
.not-found-container {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100vh;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    padding: 20px;
}

.content {
    text-align: center;
    background: white;
    padding: 60px 40px;
    border-radius: 20px;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
    max-width: 500px;
    width: 100%;
    animation: fadeIn 0.5s ease-in;
}

@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(-20px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.icon-wrapper {
    margin-bottom: 30px;
    display: inline-block;
    animation: pulse 2s ease-in-out infinite;
}

@keyframes pulse {
    0%, 100% {
        transform: scale(1);
    }
    50% {
        transform: scale(1.05);
    }
}

.access-denied-icon {
    width: 120px;
    height: 120px;
    color: #e74c3c;
    filter: drop-shadow(0 4px 6px rgba(231, 76, 60, 0.3));
}

h1 {
    font-size: 36px;
    color: #2c3e50;
    margin: 0 0 20px 0;
    font-weight: 700;
}

.message {
    font-size: 20px;
    color: #e74c3c;
    margin: 0 0 15px 0;
    font-weight: 600;
}

.sub-message {
    font-size: 16px;
    color: #7f8c8d;
    margin: 0;
    line-height: 1.6;
}

@media (max-width: 768px) {
    .content {
        padding: 40px 30px;
    }
    
    h1 {
        font-size: 28px;
    }
    
    .message {
        font-size: 18px;
    }
    
    .access-denied-icon {
        width: 100px;
        height: 100px;
    }
}
</style>